module.exports = __webpack_public_path__ + "img/jsb-down-close.1437f31b.png";